export const GET_JWELERY_REQUEST = "get-jwelery-request";
export const GET_JWELERY_SUCCESS = "get-jwelery-success";
export const GET_JWELERY_ERROR = "get-jwelery-error";
